import React, { useState } from "react"
import Loader from "../../../../components/ui/loader"
import { Button } from "../../../../components/ui/button"

interface Props {
  setShowCardDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
  onConfirmDelete: () => Promise<void> | void
  lastFour: string
  brand: string
}

const ConfirmCardDeletion: React.FC<Props> = ({
  setShowCardDeleteModal,
  onConfirmDelete,
  lastFour,
  brand,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    try {
      setIsDeleting(true)

      if (onConfirmDelete) await onConfirmDelete()

    } catch (err) {
      console.error("Error deleting card:", err)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9001]">
      <div className="relative w-[90%] md:w-[480px] bg-white rounded-[16px] main-shadow flex flex-col items-center p-6 text-center">
        <h2 className="text-[22px] md:text-[24px] font-semibold text-grayCharcoal mb-3">
          Delete this card?
        </h2>

        <p className="text-graySlate text-[15px] mb-6 max-w-[400px] leading-snug">
          You’re about to permanently remove your{" "}
          {brand ? `${brand[0].toUpperCase()}${brand.slice(1)}` : "card"} ending
          in <strong>{lastFour}</strong> from your saved payment methods.
          <br />
          <br />
          Once deleted, it can’t be used for future purchases or subscriptions.
        </p>

        <div className="flex justify-center gap-4 w-full mt-2">
          <Button
            className="w-1/3"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? <Loader /> : "Delete"}
          </Button>

          <Button
            className="w-1/3"
            variant="outline"
            onClick={() => setShowCardDeleteModal(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
        </div>

        <p className="text-graySlate text-[12px] mt-6 max-w-[400px] leading-tight">
          This only removes the card from your Zoee account. It won’t affect any
          transactions that have already been processed.
        </p>
      </div>
    </div>
  )
}

export default ConfirmCardDeletion
